<template>
  <div class="search-list">
    <b-row class="m-0 text-center instance">
      <b-col
        class="searchGutter "
        sm="12"
        md="4"
        xl="4"
        v-for="(item, index) in searchData"
        :key="index"
      >
        <div class="img_cover_box search-height">
          <div class="img-cover"></div>

          <img
            class="d-block img-fluid w-100 img_h"
            width="1024"
            height="490"
            :src="item.sourceUrl"
            alt=""
          />
        </div>
        <div class="innerbox">
          <div class="instance-txt" @click="goToDeatil(item)">
            <i class="vedio_icon" v-if="item.type == '视频'"></i>
            {{ item.postTitle }}
          </div>
          <template v-if="item.category">
            <span
              class="text-uppercase metro-btn1"
              v-for="(itemCate, indexCate) in item.category.split(',')"
              :key="indexCate"
              @click="goToNews(itemCate)"
            >
              {{ itemCate }}</span
            >
          </template>
        </div>
      </b-col>
    </b-row>
    <!-- <el-pagination background layout="prev, pager, next" :total="1000" class="mt-1 pagination"></el-pagination> -->
  </div>
</template>

<script>
export default {
  name: "SearchList",
  props: ["searchData"],
  mounted() {
    this.handelWidth();
  },
  methods: {
    handelWidth() {
      // console.log('aaaaaaaa')
      this.$nextTick(() => {
        setTimeout(() => {
          // console.log(this.searchData);
          var container = document.getElementsByClassName("search-height");
          var imgCover = document.getElementsByClassName("img-cover");

          var playerHeight = container[0].clientWidth / (16 / 9) + "px";
          // console.log(playerHeight);
          for (var i = 0; i < container.length; i++) {
            container[i].style.height = playerHeight;
            imgCover[i].style.height = playerHeight;
          }
        }, 1100);
      });
    },
    goToNews(item) {
      this.$router
        .push({
          path: "/News",
          query: {
            cT: item,
          },
        })
        .catch((err) => {
          err;
        });
    },
    goToDeatil(item) {
      this.$router.push({
        path: "/detail",
        query: {
          postId: item.postId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search-list {
  // min-height: 500px;
  clear: both;
  overflow: hidden;
  .instance {
    width: 100%;
    // min-height: 500px;
    // background: #01a2dd;
    .searchGutter {
      // padding-left: 0;
      // padding-right: 0;
      // position: relative;
      margin-bottom: 0.3rem;
      // margin: 0 15px;
      // background: url("../../../assets/imgs/home/bg_img.jpg") no-repeat;
      // background-size: 100% 100%;

      .img_cover_box {
        position: relative;
        overflow: hidden;
      }
      .img_h {
        // height: 3rem;
        height: auto;
        // height: 3rem;
      }
      .img_cover_box:hover {
        // background: rgba(0, 0, 0, 0.2);
      }
    }
    position: relative;
    color: #ffffff;
    .innerbox {
      font-size: 22px !important ;
      width: calc(100% - 0.4rem);
      // margin: 0 0.2rem;
      font-size: 0.23rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .instance-txt {
        display: inline-block;
        // width: calc(100% - 0.4rem);
        cursor: pointer;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        line-clamp: 3;
        line-height: 30px;
        font-size: 22px;
        .vedio_icon {
          display: inline-block;
          height: 20px;
          width: 20px;
          background: url("../../../assets/imgs/home/vedio_icon.png") no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
          position: relative;
          top: 0.03rem;
        }
      }
      .instance-txt:hover {
        color: #01a2dd;
      }
      // .vedio_icon {
      //   display: inline-block;
      //   height: 0.6rem;
      //   width: 0.6rem;
      //   background: url("~@/assets/imgs/home/vedio_icon.png") no-repeat;
      //   background-size: 100% 100%;
      //   cursor: pointer;
      // }
      .metro-btn1 {
        position: relative;
        // top: 0.5rem;
        border: 1.3px solid #ffffff;
        cursor: pointer;
        font-size: 9px;
        letter-spacing: 4px;
        // padding: 2px 3px 2px 5px;
        padding: 2px 3px 2px 7px;
        display: inline-block;
        margin-top: 3px;
        margin: 3px 3px 0 3px;
        font-family: Calibri Bold;
        // font-weight: bolder;
        line-height: 1.2;
      }
      .metro-btn:hover {
        background: rgba(0, 0, 0, 0.7);
        border: none;
        border: 1px solid #666;
        border-radius: 3px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .search-list {
    clear: both;
    overflow: hidden;
    .img-cover {
      width: calc(100% - 0rem);
    }
    .vedio_icon {
      display: inline-block;
      height: 20px;
      width: 20px;
      background: url("../../../assets/imgs/home/vedio_icon.png") no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      position: relative;
      top: 0.1rem;
    }
    .instance {
      .innerbox {
        .instance-txt {
          line-height: 24px;
          font-size: 20px;
          .vedio_icon {
            display: inline-block;
            height: 20px;
            width: 20px;
            background: url("../../../assets/imgs/home/vedio_icon.png")
              no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
            position: relative;
            // top: 0.1rem;
          }
        }
      }
      .searchGutter {
        padding: 0rem;
        margin-bottom: 0rem;
        .img_h {
          // height: 5.25rem;
          // height: 100%;
          height: auto;
        }
      }
    }
    .instance-txt {
      font-size: 0.5rem;
      font-weight: bold;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      line-clamp: 3;
    }
  }
  .pagination {
    display: none;
  }
}
@media screen and (min-width: 768px) {
  .metro-btn {
    // display: none;
  }
  .pagination {
    height: 0.6rem;
  }
  .pagination {
    display: block;
  }
  .img-cover {
    // width: calc(100% - 0.4rem);
    // margin: 0 0.2rem;
  }
}
</style>
